import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "sentinel"]

  connect() {
    this.previouslyFocusedElement = document.activeElement
    this.boundFocusDialog = () => this.focusDialog()
    this.boundTrapFocus = (event) => this.trapFocus(event)
    this.sentinelTargets.forEach((sentinel) => sentinel.addEventListener("focus", this.boundFocusDialog))
    window.addEventListener("keydown", this.boundTrapFocus, true)
    requestAnimationFrame(() => {
      if (this.hasDialogTarget) this.dialogTarget.focus()
    })
  }

  disconnect() {
    this.sentinelTargets.forEach((sentinel) => sentinel.removeEventListener("focus", this.boundFocusDialog))
    window.removeEventListener("keydown", this.boundTrapFocus, true)
  }

  trapFocus(event) {
    if (event.key !== "Tab" || !this.hasDialogTarget) return

    const focusableElements = this.focusableElements
    if (focusableElements.length === 0) {
      event.preventDefault()
      this.dialogTarget.focus()
      return
    }

    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    if (event.shiftKey && document.activeElement === this.dialogTarget) {
      event.preventDefault()
      lastElement.focus()
      return
    }

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault()
      this.dialogTarget.focus()
      return
    }

    if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault()
      this.dialogTarget.focus()
    }
  }

  focusDialog() {
    if (this.hasDialogTarget) this.dialogTarget.focus()
  }

  close(event) {
    event?.preventDefault()
    this.frame.innerHTML = ""
    if (this.previouslyFocusedElement?.isConnected) this.previouslyFocusedElement.focus()
  }

  get frame() {
    return this.element.closest("turbo-frame") || this.element
  }

  get focusableElements() {
    return Array.from(this.dialogTarget.querySelectorAll([
      "a[href]",
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "[tabindex]:not([tabindex='-1'])"
    ].join(","))).filter((element) => element.offsetParent !== null)
  }
}
